'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    AudioCover = require('../molecules/AudioCover'),
    PlayerTitle = require('../atoms/PlayerTitle'),
    Button = require('../atoms/Button'),
    Icon = require('../atoms/Icon'),
    PlayerActionCreators = require('../actions/PlayerActionCreators'),
    StampLink = require('../atoms/StampLink'),
    { PropTypes } = React;

require('./StickyPlayer.less');

var StickyPlayer = React.createClass({
  mixins: [PureRenderMixin, ClassNameMixin],

  propTypes: {
    uuid: PropTypes.string.isRequired,
    track: PropTypes.shape({
      url: PropTypes.string.isRequired,
      duration: PropTypes.number.isRequired
    }).isRequired,
    artwork: PropTypes.object.isRequired,
    colors: PropTypes.object.isRequired,
    sourceStamp: PropTypes.object,
    currentTime: PropTypes.number.isRequired,
    isPlaying: PropTypes.bool.isRequired,
    isPaused: PropTypes.bool.isRequired,
    onPlay: PropTypes.func.isRequired,
    onPause: PropTypes.func.isRequired,
    onBackward: PropTypes.func.isRequired,
    onForward: PropTypes.func.isRequired
  },

  render() {
    var { track, sourceStamp, artwork, colors } = this.props;

    return (
      <div className={this.getClassName()}>
        <AudioCover context='StickyPlayer'
                    size='small'
                    linkUrl={track.url}
                    colors={colors}
                    artwork={artwork}
                    duration={track.duration}
                    {...this.props}>
          <Button className='StickyPlayer-close'
                  onClick={this.handleCloseClick}
                  size='xsmall'
                  color='dark'
                  round
                  fill>
            <Icon name='cross'
                  mode='stroke'
                  size='xxsmall' />
          </Button>
        </AudioCover>
        <div className='StickyPlayer-meta'>
          <PlayerTitle title={track.title}
                       username={track.username}
                       linkUrl={track.url}
                       context='StickyPlayer' />
          {sourceStamp &&
            <div className='StickyPlayer-stampLink'>
              from <StampLink className='StickyPlayer-title'
                              bold
                              stamp={sourceStamp} />
            </div>
          }
        </div>
      </div>
    );
  },

  handleCloseClick() {
    PlayerActionCreators.pause(this.props.uuid);
    PlayerActionCreators.considerRemoveStickyMedia(true);
  }
});

module.exports = StickyPlayer;



/** WEBPACK FOOTER **
 ** ./organisms/StickyPlayer.jsx
 **/